/* eslint-disable no-console */
import type { Fragment, Schema } from '@atlaskit/editor-prosemirror/model';

import { adfResponseToFragment } from '../../../ui/utils/request/adf-response';
import type { ADFResponse } from '../../ai-session-context/types';

/**
 * Converts ADF response to ProseMirror Fragment
 */
export function convertADFToFragment( schema: Schema, adfResponse?: ADFResponse): Fragment | null {
	if (!adfResponse) {
		return null;
	}

	try {
		const pmNode = adfResponseToFragment({ schema, adfResponse });
		return pmNode;
	} catch {
		return null;
	}
}

/**
 * Validates fragment health by checking each node
 */
export function fragmentIsHealthy(fragment: Fragment): boolean {
	let isHealthy = true;

	fragment.forEach((node) => {
		if (!isHealthy) {
			return;
		}
		try {
			node.check();
		} catch {
			isHealthy = false;
		}
	});

	return isHealthy;
}
